import { defineComponent } from 'vue';
import './roving-focus-group-impl.mjs';
import { ElCollection } from './roving-focus-group.mjs';
import script$1 from './roving-focus-group-impl.vue_vue_type_script_lang.mjs';

var script = defineComponent({
  name: "ElRovingFocusGroup",
  components: {
    ElFocusGroupCollection: ElCollection,
    ElRovingFocusGroupImpl: script$1
  }
});

export { script as default };
//# sourceMappingURL=roving-focus-group.vue_vue_type_script_lang.mjs.map
